import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PayAccountsMutationVariables = Types.Exact<{
  count: Types.Scalars['Int']['input'];
  addToCurrentPeriod: Types.Scalars['Boolean']['input'];
  paymentMethodId: Types.Scalars['Int']['input'];
}>;


export type PayAccountsMutationPage = { readonly __typename?: 'RootMutationType', readonly payAccounts: { readonly __typename?: 'YalperChargeResult', readonly confirmationUrl?: string | null } };


export const PayAccountsDocument = gql`
    mutation PayAccounts($count: Int!, $addToCurrentPeriod: Boolean!, $paymentMethodId: Int!) {
  payAccounts(
    count: $count
    addToCurrentPeriod: $addToCurrentPeriod
    paymentMethodId: $paymentMethodId
  ) {
    confirmationUrl
  }
}
    `;
export type PayAccountsMutationFn = Apollo.MutationFunction<PayAccountsMutationPage, PayAccountsMutationVariables>;

/**
 * __usePayAccountsMutation__
 *
 * To run a mutation, you first call `usePayAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payAccountsMutation, { data, loading, error }] = usePayAccountsMutation({
 *   variables: {
 *      count: // value for 'count'
 *      addToCurrentPeriod: // value for 'addToCurrentPeriod'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function usePayAccountsMutation(baseOptions?: Apollo.MutationHookOptions<PayAccountsMutationPage, PayAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayAccountsMutationPage, PayAccountsMutationVariables>(PayAccountsDocument, options);
      }
export type PayAccountsMutationHookResult = ReturnType<typeof usePayAccountsMutation>;
export type PayAccountsMutationResult = Apollo.MutationResult<PayAccountsMutationPage>;
export type PayAccountsMutationOptions = Apollo.BaseMutationOptions<PayAccountsMutationPage, PayAccountsMutationVariables>;